import { render, staticRenderFns } from "./PartnersHeader.vue?vue&type=template&id=5c0fe671&"
import script from "./PartnersHeader.vue?vue&type=script&lang=js&"
export * from "./PartnersHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports